/**
 * The mandatory-training documents shown on the public form (registration spec).
 *
 * Configuration rather than transactional data — it changes when Parinaam
 * updates the training files, which is rare — so it is cached like reference
 * data. A failure to load is handled gently on the form: the acknowledgement
 * still works, the links are simply absent.
 */

import { useQuery } from '@tanstack/react-query';
import { fetchTrainingMaterials } from '../services/api/registration-requests';

const STALE_TIME_MS = 5 * 60 * 1000;

export function useTrainingMaterials() {
  return useQuery({
    queryKey: ['training-materials'],
    queryFn: fetchTrainingMaterials,
    staleTime: STALE_TIME_MS,
  });
}
